<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-card>
      <form @submit.prevent="onSubmit">
        <v-card-title>
          <p class="headline mb-1" style="width: 100%">
            {{ mess.dialog_wishlist_title }}
          </p>
          <b
            v-if="company"
            style="font-size: 14px; line-height: 1"
            :style="{ color: siteColors.primary }"
            class="mb-0"
          >
            {{ company.name }}
          </b>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-card flat>
              <v-row v-if="companies">
                <v-col cols="12" class="pa-0">
                  <v-autocomplete
                    v-model="customCompany"
                    v-validate="required['customCompany']"
                    :items="companies"
                    item-text="title"
                    item-value="id"
                    outlined
                    dense
                    :label="mess.dialog_base_field_company"
                    :error-messages="errors.collect('customCompany')"
                    data-vv-name="customCompany"
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pa-0">
                  <v-text-field
                    v-model="wishlistTitle"
                    v-validate="required['wishlistTitle']"
                    outlined
                    dense
                    :label="mess.dialog_wishlist_field_wishlist_title"
                    :error-messages="errors.collect('wishlistTitle')"
                    data-vv-name="wishlistTitle"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pa-0">
                  <v-textarea
                    v-model="wishlistDescription"
                    outlined
                    dense
                    :label="mess.dialog_wishlist_field_wishlist_description"
                  >
                  </v-textarea>
                </v-col>
              </v-row>
            </v-card>
          </v-container>
          <small>{{ mess.dialog_base_required_label }}</small>
        </v-card-text>
        <v-card-actions style="padding: 0 24px 16px">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="elevation-0"
            dark
            outlined
            @click="dialog = false"
          >
            {{ mess.dialog_base_button_close }}
          </v-btn>
          <v-btn
            type="submit"
            color="primary"
            class="elevation-0"
            :loading="loading"
            dark
          >
            {{ mess.dialog_base_button_add }}
          </v-btn>
        </v-card-actions>
      </form>
      <v-btn absolute top right text icon @click="dialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
// Services
import { wishlistService } from "@/services/wishlist-service/wishlist-service";

// Models
import notifications from "@/models/notificationTemplates";

export default {
  $_veeValidate: {
    validator: "new"
  },
  name: "WishlistAddingDialog",
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    company: {
      type: [Object, null],
      default: null
    },
    companies: {
      type: [Array, null],
      default: null
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      wishlist: null,
      companyNewWL: null,
      customCompany: null,
      wishlistTitle: "",
      wishlistDescription: "",
      dictionary: {
        custom: {
          customCompany: {
            required: () => ""
          },
          wishlistTitle: {
            required: () => ""
          }
        }
      }
    };
  },
  computed: {
    required() {
      return { customCompany: "required", wishlistTitle: "required" };
    }
  },
  watch: {
    isVisible(val) {
      this.dialog = val;
    },
    dialog(val) {
      this.$emit("update:is-visible", val);
    }
  },
  mounted() {
    this.$validator.localize("ru", this.dictionary);
  },
  methods: {
    resetWishlistDialog() {
      this.wishlistTitle = "";
      this.wishlistDescription = "";
      this.customCompany = null;
      this.$validator.reset();
    },
    onSubmit() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;

          // Создание нового wishlist
          wishlistService
            .addWishlist({
              companyId: this.company?.id || this.customCompany,
              title: this.wishlistTitle,
              description: this.wishlistDescription
            })
            .then(wishlist => {
              this.company?.id
                ? this.$emit("update-wishlists", { id: this.company.id })
                : this.$emit("insert-wishlist", {
                    ...wishlist,
                    company: this.companies.find(
                      c => c.id === this.customCompany
                    )?.title,
                    company_id: this.companies.find(
                      c => c.id === this.customCompany
                    )?.id
                  });
              this.dialog = false;
              this.resetWishlistDialog();
              this.$emit("wishlist-added", notifications.success.wishlistAdded);
            })
            .catch(() => {
              this.$emit("wishlist-added", notifications.error.base);
            })
            .finally(() => (this.loading = false));
        }
      });
    }
  }
};
</script>

<style lang="scss">
.v-text-field--outlined.v-input--is-focused fieldset,
.v-text-field--outlined.v-input--has-state fieldset {
  border-width: 1px !important;
}

a.wishlist-article {
  text-transform: uppercase;
  color: #1a1a1a !important;
  text-decoration: none;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.3;
  transition: color 200ms;

  &:hover {
    color: var(--v-primary-base) !important;
  }
}
</style>
